<template>
  <component
    :is="componentCard"
    class="casino-highlight-card"
    :cardNumber="cardNumber"
  />
</template>

<script lang="ts">
import { defineComponent, computed, watchEffect } from "vue";
import {
  injectTemplateSize,
  TemplateSizeContext
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import MPUCard from "./MPUCasinoHighlight.vue";

export default defineComponent({
  name: "CasinoHighlightSelector",
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true },
    cardNumber: { type: String, required: false, default: "1" }
  },
  setup() {
    const template = injectTemplateSize() as TemplateSizeContext;

    const componentCard = computed(() => {
      return MPUCard;
    });

    return {
      componentCard
    };
  }
});
</script>
